var React = require('react');

function HotspotNode (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11.6244 0.133975C11.9338 -0.0446581 12.315 -0.0446583 12.6244 0.133975L23.7487 6.55662C24.0581 6.73526 24.2487 7.06538 24.2487 7.42265V20.2679C24.2487 20.6252 24.0581 20.9553 23.7487 21.134L12.6244 27.5566C12.315 27.7353 11.9338 27.7353 11.6244 27.5566L0.5 21.134C0.190599 20.9553 0 20.6252 0 20.2679V7.42265C0 7.06538 0.190599 6.73526 0.5 6.55662L11.6244 0.133975Z","fill":"white","key":0}),React.createElement("path",{"d":"M10.9345 12.7496V8.84534H13.3155V12.7496H17.125V15H13.3155V18.8453H10.9345V15H7.125V12.7496H10.9345Z","fill":"#FF8F15","key":1})]);
}

HotspotNode.defaultProps = {"width":"25","height":"28","viewBox":"0 0 25 28","fill":"none"};

module.exports = HotspotNode;

HotspotNode.default = HotspotNode;
